<template>
  <div class="summaryPanel">
    <div class="panel panel-default">
      <div class="panel-heading" :style="this.styling">
        <div class="row">
          <div class="col-xs-10">
            <h4>
              <slot name="title">something</slot>
            </h4>
          </div>
          <div class="col-xs-2" style="text-align: right">
            <!-- <a v-if="anchor" :href="anchor">
              <i class="fas fa-external-link-alt"></i>
            </a> -->
            <router-link
              v-if="anchor"
              :to="anchor"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              ><i class="fas fa-external-link-alt"></i
            ></router-link>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <slot name="body">nothing</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['anchor', 'styling'],
  data() {
    return {
      scrollOptions: {
        duration: this.scrollDuration,
        offset: this.scrollOffset,
      },
      scrollOffset: -140,
      scrollDuration: 1000,
    };
  },
};
</script>

<style></style>
